import { RenderAppropriate } from '../../internals/RenderAppropriate';
import { CardFooterStyle } from '../../styles/display/card.styles';
import React, { ReactNode, ComponentType } from 'react';

interface CardFooterProps {
    children?: ReactNode;
    component?: ComponentType<any>;
    [key: string]: any;
}

const CardFooter: React.FC<CardFooterProps> & { Style?: any } = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(CardFooterStyle, rest, children, Component);

CardFooter.Style = CardFooterStyle;

export { CardFooter };
